import {
  Spaceable
} from "./chunk.LC2BHSCA.js";
import {
  to
} from "./chunk.3OP6Y2IJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  respondTo
} from "./chunk.PSCGDE4H.js";
import {
  D,
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  e,
  n,
  r as r3
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-navigation-tags/jb-navigation-tags.scss?inline
var jb_navigation_tags_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
.with-underline .list-item {
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  position: relative;
  transform: translateZ(0);
}
.with-underline .list-item::before {
  animation-direction: reverse;
  background-color: rgba(241, 242, 242, 0.3);
  bottom: 0;
  content: "";
  height: 66%;
  left: 0;
  position: absolute;
  transition: height 0.9s ease-out 0.2s;
  width: 1px;
}
.with-underline .list-item::after {
  background: #fff;
  bottom: 0;
  content: "";
  height: 1px;
  left: 0;
  position: absolute;
  right: 50%;
  transition: right 0.9s ease-out 0.2s;
}

/* stylelint-disable */
/* stylelint-enable */
label {
  font-family: var(--theme-font-black-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-black-weight, 900);
}

.list-item {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

label {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 0.688rem;
  letter-spacing: 0.125rem;
  line-height: 1rem;
  text-decoration: none;
  text-transform: uppercase;
}

.list-item {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 0.688rem;
  letter-spacing: 0.063rem;
  line-height: 1rem;
}

/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
}

nav {
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  justify-content: center;
  box-sizing: border-box;
  flex-basis: 100%;
  max-width: 100%;
  padding: 0 0;
  width: 100%;
}
@media (min-width: 1281px) {
  nav {
    box-sizing: border-box;
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    padding: 0 20px;
    width: 83.3333333333%;
  }
}

jb-section-headline {
  padding-block-end: var(--spacing-sm);
}

input {
  display: none;
}
input:checked ~ ul {
  max-block-size: 60em;
}
input:checked ~ .title-wrapper label::before {
  content: attr(data-close);
}

label {
  align-items: flex-end;
  cursor: pointer;
  display: flex;
  justify-content: center;
  text-transform: uppercase;
}
label::before {
  content: attr(data-open);
}

.title-wrapper {
  align-items: flex-end;
  display: flex;
  justify-content: center;
  padding-block-start: var(--spacing-sm);
}

jb-chevron-icon {
  margin-inline-start: 5px;
}

ul {
  align-items: center;
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  gap: var(--spacing-xs);
  max-block-size: calc(var(--spacing-xs) * 3 + 112px);
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}
@media (min-width: 600px) {
  ul {
    flex-direction: initial;
    flex-wrap: wrap;
    justify-content: center;
    max-block-size: calc(var(--spacing-xs) * 1 + 56px);
  }
}

.list-item {
  display: flex;
}
.list-item:hover a {
  border: 1px solid #141e55;
  transition: border 0.7s ease-in-out 0s;
}
.list-item a {
  border: 1px solid rgba(20, 30, 85, 0.2);
  color: #141e55;
  padding: 5px 10px;
  text-decoration: none;
  text-transform: uppercase;
  transition: border 0.7s ease-in-out 0s;
  white-space: pre;
}
.list-item a:hover {
  text-decoration: none;
}

.with-underline .animate-left-bottom::before {
  background-color: transparent;
  block-size: 0;
  border-block-end: 1px solid var(--stroke-color, rgba(20, 30, 85, 0.2));
  content: "";
  inline-size: 100%;
  position: absolute;
}
.with-underline .animate-left-bottom::after {
  background: #141e55;
  inset-inline: 0 100%;
  transition-delay: 0s;
  transition-duration: 0.8s;
  transition-timing-function: ease-in-out;
}
.with-underline .animate-left-bottom.active::after, .with-underline .animate-left-bottom:hover::after {
  background: #141e55;
  inset-inline-end: 0;
  transition-delay: 0s;
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
}

.with-underline ul {
  flex-direction: unset;
  flex-wrap: wrap;
  justify-content: center;
}

.with-underline .list-item {
  border: none;
  display: inline-block;
  letter-spacing: 0.094rem;
  padding-block-end: 4px;
  pointer-events: initial;
  position: relative;
}
.with-underline .list-item a {
  border: none;
  color: #141e55;
  opacity: 0.4;
  padding: 0;
  transition: opacity 0.4s ease-in-out 0s;
}
.with-underline .list-item:hover a {
  opacity: 1;
  transition: opacity 0.4s ease-in-out 0s;
}

.with-underline .list-item.active a {
  opacity: 1;
}
.with-underline .list-item.active::before {
  background-color: #141e55;
  transition: background-color 0.8s ease-in-out 0s;
}`;

// src/components/jb-navigation-tags/jb-navigation-tags.ts
var JbNavigationTags = class extends Spaceable(r2) {
  constructor() {
    super(...arguments);
    this._showButton = false;
  }
  firstUpdated() {
    const relatedTags = this.renderRoot.querySelectorAll(".navigation-tags.with-underline .list .list-item");
    relatedTags.forEach((el) => {
      el.addEventListener("click", () => {
        const parent = el.parentNode;
        const active = parent?.querySelector(".list-item.active");
        if (active) active.classList.remove("active");
        el.classList.add("active");
      });
    });
    window.addEventListener("resize", () => {
      this._calculateShowButton();
    });
    setTimeout(() => {
      this._calculateShowButton();
    }, 0);
  }
  _calculateShowButton() {
    const element = this._list.firstElementChild;
    const styles = window.getComputedStyle(element);
    const heightWithMargin = element.offsetHeight + parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
    const actualHeight = this._list.scrollHeight - 30;
    if (respondTo({ xs: "mobile", sm: "desktop" }) === "mobile") {
      if (actualHeight >= heightWithMargin * 4) {
        this._showButton = true;
      } else {
        this._showButton = false;
      }
    } else {
      if (actualHeight >= heightWithMargin * 2) {
        this._showButton = true;
      } else {
        this._showButton = false;
      }
    }
  }
  _getContentSpacingProperties() {
    return { colsMdUp: 12, type: "navigation-tags" };
  }
  _renderItem(item) {
    return ke`<li
      class="list-item animate-left-bottom ${item.tag === this.activeItem ? "active" : ""}"
      data-search-action-url=${to(item.searchAction)}
      data-search-suggest-url=${to(item.suggestUrl)}
    >
      <a
        href=${to(item.link.href)}
        data-tag=${item.tag}
        @click=${this._trackClicks}
        >${item.tag}</a
      >
    </li>`;
  }
  _trackClicks(evt) {
    const eventTarget = evt.composedPath()[0];
    const tag = eventTarget.dataset.tag ?? evt.detail.label;
    const url = eventTarget.href ?? evt.detail.newValue;
    this.dispatchEvent(
      new CustomEvent("jb-navigation-tags:filter", {
        detail: {
          tag,
          url
        },
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return ke`<nav
      role="navigation"
      aria-label="Tag navigation"
      class="navigation-tags ${this.type}"
    >
      <input
        type="checkbox"
        id="checkbox"
        @change=${() => this.requestUpdate()}
      />
      ${this.heading ? ke`<jb-section-headline .headline=${this.heading}></jb-section-headline>` : D}
      <ul class="list">
        ${this.items.map((item) => this._renderItem(item))}
      </ul>
      ${this._showButton ? ke` <div class="title-wrapper">
            <label
              for="checkbox"
              data-open="${this.toOpenText}"
              data-close="${this.toCloseText}"
            >
              <jb-chevron-icon direction=${this._input?.checked ? "up" : "down"}></jb-chevron-icon>
            </label>
          </div>` : D}
    </nav>`;
  }
};
JbNavigationTags.styles = r(jb_navigation_tags_default);
__decorateClass([
  n()
], JbNavigationTags.prototype, "activeItem", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "heading", 2);
__decorateClass([
  n({ type: Array })
], JbNavigationTags.prototype, "items", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "toCloseText", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "toOpenText", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "type", 2);
__decorateClass([
  e("input")
], JbNavigationTags.prototype, "_input", 2);
__decorateClass([
  e(".list")
], JbNavigationTags.prototype, "_list", 2);
__decorateClass([
  r3()
], JbNavigationTags.prototype, "_showButton", 2);
JbNavigationTags = __decorateClass([
  customElement("jb-navigation-tags")
], JbNavigationTags);

export {
  JbNavigationTags
};
